import { type CarrierDef } from '../common.js'
import { accountNumber, userPassMap } from '../internal.js'

const credentialTypes = [accountNumber, 'client-id', 'client-secret'] as const
const locationCredentialTypes = [accountNumber]

export type upssCredType =
  | (typeof credentialTypes)[number]
  | (typeof locationCredentialTypes)[number]

export const upss: CarrierDef<upssCredType> = {
  name: 'UPS',
  scac: 'upss',
  parcelServices: [
    { id: 'ground', name: 'UPS Ground' },
    { id: 'next_day', name: 'UPS Next Day Air' },
    { id: 'next_day_saver', name: 'UPS Next Day Air Saver' },
    { id: 'next_day_early', name: 'UPS Next Day Air Early' },
    { id: 'second_day', name: 'UPS 2nd Day Air' },
    { id: 'second_day_am', name: 'UPS 2nd Day Air A.M.' },
    { id: 'three_day_select', name: 'UPS 3 Day Select' },
  ],
  credentialTypes,
  locationCredentialTypes,
  legacyCredMap: [
    ...userPassMap,
    ['account-number', 'accountNumber'],
    ['client-id', 'clientId'],
    ['client-secret', 'clientSecret'],
  ],
  engineLayers: ['rating', 'bol', 'pickup', 'tracking'],
  credentialConfig: {
    'account-number': { customerIdentifier: true },
  },
}
